import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleFetchFulfilled,
  handleFetchPending,
  handleFetchRejected,
} from "redux/helpers/fetching"
import { createIssue } from "redux/features/issue/issueThunk"

const issueAdapter = createEntityAdapter()
export const initialState = issueAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const issueSlice = createSlice({
  name: "issue",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(createIssue.pending, (state) => handleFetchPending(state))
      .addCase(createIssue.rejected, (state) => handleFetchRejected(state))
      .addCase(createIssue.fulfilled, (state) => handleFetchFulfilled(state))
  },
})

export const selectFetchStatus = (state: RootState) =>
  state.features.issue.fetchStatus

export default issueSlice.reducer
